export default __webpack_public_path__ + "static/media/message.a1ca286b.svg";